<template>
    <b-card no-body>

        <b-modal id="update" :title="['Güncelle',services.Name || null].join(' - ')" body-class="p-0"  no-close-on-esc no-close-on-backdrop>
            <sms-integration-update-value v-model="parameters"></sms-integration-update-value>
            <template #modal-footer><v-executer :action="update" text="Güncelle" :loading="loading"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    search
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { SystemDataApi } from '@/api/system-data'
import { SystemParameterApi } from '@/api/system-parameter'
import SMSIntegrationUpdateValue from './components/SMSIntegrationUpdateValue.vue'
export default {
    components:{
        BCard,
        "sms-integration-update-value":SMSIntegrationUpdateValue
    },
    data(){
        return{
            fields:[
                {name:'SMS Servisi',key:'Name',thClass:'w-100',sortable:true}
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit }
            ],
            services:{
                Value:null,
                Name:null
            },
            loading:false,
            parameters:[]
        }
    },
    methods:{
        clearForm(){
            this.services.Value = null
            this.services.Name = null
            this.parameters = []
        },
        provider(){
            return SystemDataApi.SMSServices()
        },
        edit(item){
            this.$refs.table.rowLoading(true)
            this.clearForm()
            this.services.Value = item.Value
            this.services.Name = item.Name
            SystemParameterApi.SMS(item.Value).then(res=>{
                this.$refs.table.rowLoading(false)
                if(res.data.Success){
                    this.parameters = res.data.Data
                    this.$showModal('update')
                }else this.$result(res)
            }).catch(err=>{
                this.$refs.table.rowLoading(false)
                this.$result(null,res)
            })
        },
        update(){
            this.loading = true
            const values = this.parameters?.map(p=>{ return { Id:p.Id,Value:p.Value,Key:p.Key,SmsProvider:p.SmsProvider } }) || []
            SystemParameterApi.SMSUpdate(values).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('update')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        }
    }
}
</script>

<style>

</style>